var GridPreset = function(params){
    var self = this;
    self.name = ko.observable(params && params.name || '');
    self.label = ko.observable(params && params.label || '');
    self.columns = ko.observableArray(params && params.columns || []);
    self.selected = ko.observable(params && params.selected || true);

    self.getData = function() {
        return {
            name: self.name(),
            label: self.label(),
            columns: self.columns(),
        };
    };
};